module.exports = __webpack_public_path__ + "img/faq1.88498a8a.svg";